import styled from 'styled-components';

export const Row = styled.tr`
  height: 100%;
`;
